
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Enum.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export enum LegalCaseStatus {
	New = 0,
	Closed = 1
}
export namespace LegalCaseStatus {
	export function getKeys(): Map<LegalCaseStatus, string> {
		return new Map([[0, 'New'], [1, 'Closed']]);
	}
}
